export const VIN_RE = /^[A-HJ-NPR-Z0-9]{17}$/i;

export const WMI_MAP = {
    WBA: 'BMW',
    WBS: 'BMW',
    WBY: 'BMW',
    WB1: 'BMW',
    WB3: 'BMW',
    WBW: 'BMW',
    WBX: 'BMW',
    '4US': 'BMW',
    '5UX': 'BMW',
    '5YM': 'BMW',
    X4X: 'BMW',
    LBV: 'BMW',
    WMW: 'Mini',
    WMX: 'Mini',
    SAX: 'Mini',
    WME: 'Smart',
    VS9: 'Smart',
    W1K: 'Mercedes-Benz',
    W1N: 'Mercedes-Benz',
    W1V: 'Mercedes-Benz',
    W1Y: 'Mercedes-Benz',
    W1W: 'Mercedes-Benz',
    W1X: 'Mercedes-Benz',
    WDB: 'Mercedes-Benz',
    WDC: 'Mercedes-Benz',
    WDD: 'Mercedes-Benz',
    WDF: 'Mercedes-Benz',
    WDR: 'Mercedes-Benz',
    '4JG': 'Mercedes-Benz',
    '55S': 'Mercedes-Benz',
    LE4: 'Mercedes-Benz',
    WAU: 'Audi',
    WA1: 'Audi',
    WAP: 'Audi',
    WAV: 'Audi',
    WA6: 'Audi',
    WUA: 'Audi',
    TRU: 'Audi',
    '93U': 'Audi',
    WVW: 'Volkswagen',
    WV1: 'Volkswagen',
    WV2: 'Volkswagen',
    WV3: 'Volkswagen',
    WVG: 'Volkswagen',
    '3VW': 'Volkswagen',
    '1VW': 'Volkswagen',
    '9BW': 'Volkswagen',
    XW8: 'Volkswagen',
    LSV: 'Volkswagen',
    AAV: 'Volkswagen',
    WP0: 'Porsche',
    WP1: 'Porsche',
    WP2: 'Porsche',
    W0L: 'Opel',
    W0V: 'Opel',
    W0R: 'Opel',
    WOL: 'Opel',
    VXK: 'Vauxhall',
    TMB: 'Škoda',
    TMK: 'Škoda',
    TMP: 'Škoda',
    VSS: 'SEAT',
    VSX: 'SEAT',
    JT2: 'Toyota',
    JT3: 'Toyota',
    JT4: 'Toyota',
    JT5: 'Toyota',
    JT6: 'Toyota',
    JT8: 'Toyota',
    JTB: 'Toyota',
    JTD: 'Toyota',
    JTE: 'Toyota',
    JTG: 'Toyota',
    JTK: 'Toyota',
    JTL: 'Toyota',
    JTM: 'Toyota',
    JTN: 'Toyota',
    JTP: 'Toyota',
    '2T1': 'Toyota',
    '2T2': 'Toyota',
    '2T3': 'Toyota',
    '4T1': 'Toyota',
    '4T3': 'Toyota',
    '5TB': 'Toyota',
    '5TD': 'Toyota',
    '5TE': 'Toyota',
    '5TF': 'Toyota',
    '7FA': 'Toyota',
    NMT: 'Toyota',
    SB1: 'Toyota',
    VNK: 'Toyota',
    XW7: 'Toyota',
    Z8T: 'Toyota',
    '9BR': 'Toyota',
    AHT: 'Toyota',
    MBJ: 'Toyota',
    JTH: 'Lexus',
    JTJ: 'Lexus',
    '2T2Z': 'Lexus',
    JN7: 'Infiniti',
    JNK: 'Infiniti',
    JNR: 'Infiniti',
    JHM: 'Honda',
    JHL: 'Honda',
    JHG: 'Honda',
    JHZ: 'Honda',
    '1HG': 'Honda',
    '2HG': 'Honda',
    '2HK': 'Honda',
    '2HJ': 'Honda',
    '3HG': 'Honda',
    '5FN': 'Honda',
    '5J6': 'Honda',
    '5J8': 'Honda',
    '5KB': 'Honda',
    LVH: 'Honda',
    NLA: 'Honda',
    JN1: 'Nissan',
    JN3: 'Nissan',
    JN6: 'Nissan',
    JN8: 'Nissan',
    '1N4': 'Nissan',
    '1N6': 'Nissan',
    '3N1': 'Nissan',
    '3N6': 'Nissan',
    '3N8': 'Nissan',
    '5N1': 'Nissan',
    VSK: 'Nissan',
    X7L: 'Renault',
    NNA: 'Renault',
    VF1: 'Renault',
    VF2: 'Renault',
    VF6: 'Renault',
    VF8: 'Renault',
    '93Y': 'Renault',
    KMH: 'Hyundai',
    KMJ: 'Hyundai',
    KM8: 'Hyundai',
    KMF: 'Hyundai',
    '5NP': 'Hyundai',
    '5NM': 'Hyundai',
    LBE: 'Hyundai',
    NMA: 'Hyundai',
    Z94: 'Hyundai',
    MAL: 'Hyundai',
    AC5: 'Hyundai',
    ADD: 'Hyundai',
    KNA: 'Kia',
    KNB: 'Kia',
    KND: 'Kia',
    KNE: 'Kia',
    KNH: 'Kia',
    KNM: 'Kia',
    '5XX': 'Kia',
    '5XY': 'Kia',
    '3KP': 'Kia',
    U5Y: 'Kia',
    JF1: 'Subaru',
    JF2: 'Subaru',
    '4S3': 'Subaru',
    '4S4': 'Subaru',
    '4S6': 'Subaru',
    JM1: 'Mazda',
    JMZ: 'Mazda',
    '1YV': 'Mazda',
    '4F2': 'Mazda',
    '4F4': 'Mazda',
    JMB: 'Mitsubishi',
    JA3: 'Mitsubishi',
    JA4: 'Mitsubishi',
    '4A3': 'Mitsubishi',
    '4A4': 'Mitsubishi',
    '6MM': 'Mitsubishi',
    MMB: 'Mitsubishi',
    MMT: 'Mitsubishi',
    JS1: 'Suzuki',
    JS2: 'Suzuki',
    JS3: 'Suzuki',
    JSA: 'Suzuki',
    KL5: 'Suzuki',
    MA3: 'Suzuki',
    MBH: 'Suzuki',
    JAA: 'Isuzu',
    JAB: 'Isuzu',
    JAC: 'Isuzu',
    JAE: 'Isuzu',
    NLE: 'Isuzu',
    MBK: 'Isuzu',
    '1FA': 'Ford',
    '1FB': 'Ford',
    '1FC': 'Ford',
    '1FD': 'Ford',
    '1FM': 'Ford',
    '1FT': 'Ford',
    '1FU': 'Ford',
    '1FV': 'Ford',
    '1ZV': 'Ford',
    '2FA': 'Ford',
    '2FM': 'Ford',
    '2FT': 'Ford',
    '3FA': 'Ford',
    '3FE': 'Ford',
    '4M2': 'Mercury',
    WF0: 'Ford',
    WFO: 'Ford',
    LVS: 'Ford',
    NM0: 'Ford',
    NM1: 'Ford',
    SFA: 'Ford',
    SFD: 'Ford',
    '9BF': 'Ford',
    MAJ: 'Ford',
    AFA: 'Ford',
    '1G1': 'Chevrolet',
    '1GC': 'Chevrolet',
    '1GN': 'Chevrolet',
    '1GA': 'Chevrolet',
    '1GB': 'Chevrolet',
    '2G1': 'Chevrolet',
    '3G1': 'Chevrolet',
    KL1: 'Chevrolet',
    KL3: 'Chevrolet',
    KL6: 'Chevrolet',
    KL7: 'Chevrolet',
    KLA: 'Chevrolet',
    KLU: 'Chevrolet',
    XWB: 'Chevrolet',
    '9BG': 'Chevrolet',
    MA6: 'Chevrolet',
    '8AG': 'Chevrolet',
    '1GT': 'GMC',
    '1GD': 'GMC',
    '1GK': 'GMC',
    '1G2': 'Pontiac',
    '1G3': 'Oldsmobile',
    '1G4': 'Buick',
    '2G4': 'Buick',
    '3G5': 'Buick',
    '1G6': 'Cadillac',
    '1G8': 'Saturn',
    '1LN': 'Lincoln',
    '5L': 'Lincoln',
    '5LM': 'Lincoln',
    '5LT': 'Lincoln',
    '19U': 'Acura',
    JH4: 'Acura',
    '1C3': 'Chrysler',
    '2C3': 'Chrysler',
    '2A4': 'Chrysler',
    '1B3': 'Dodge',
    '1B4': 'Dodge',
    '1B7': 'Dodge',
    '1D4': 'Dodge',
    '1D7': 'Dodge',
    '1D8': 'Dodge',
    '2D4': 'Dodge',
    '2D8': 'Dodge',
    '1C4': 'Jeep',
    '1J4': 'Jeep',
    '1J8': 'Jeep',
    '1C6': 'RAM',
    '3C6': 'RAM',
    ZFA: 'Fiat',
    ZFC: 'Fiat',
    ZFF: 'Ferrari',
    ZAR: 'Alfa Romeo',
    ZLA: 'Lancia',
    ZAM: 'Maserati',
    ZAP: 'Piaggio',
    ZHW: 'Lamborghini',
    NM4: 'Fiat',
    '8AP': 'Fiat',
    ZAC: 'Iveco',
    VF3: 'Peugeot',
    VF7: 'Citroen',
    VF9: 'Bugatti',
    VNE: 'Alpine',
    SAJ: 'Jaguar',
    SAL: 'Land Rover',
    SCA: 'Rolls-Royce',
    SCB: 'Bentley',
    SCC: 'Lotus',
    SCF: 'Aston Martin',
    SBM: 'McLaren',
    YV1: 'Volvo',
    YV4: 'Volvo',
    YV2: 'Volvo',
    YV3: 'Volvo',
    YS2: 'Scania',
    YS3: 'Saab',
    XTA: 'Lada',
    XTT: 'UAZ',
    XTC: 'KamAZ',
    XTH: 'GAZ',
    Y6D: 'ZAZ',
    Y7A: 'Bogdan',
    LGB: 'Chery',
    LVV: 'Chery',
    L11: 'Chery',
    LSJ: 'MG',
    LFV: 'FAW',
    LFP: 'FAW',
    LFM: 'FAW',
    LFB: 'FAW',
    LDC: 'Dongfeng',
    LGH: 'Zhengzhou',
    LGX: 'BYD',
    L6T: 'Geely',
    LB3: 'Geely',
    LSK: 'SAIC',
    LGW: 'Haval',
    LZW: 'Wuling',
    LJC: 'JAC',
    LJD: 'Zotye',
    LMG: 'GAC',
    LNB: 'BAIC',
    '5YJ': 'Tesla',
    '7SA': 'Tesla',
    LRW: 'Tesla',
    XP7: 'Tesla',
    KPB: 'SsangYong',
    KPT: 'SsangYong',
    KMT: 'Genesis',
    MA1: 'Mahindra',
    MAT: 'Tata',
    MAK: 'Nissan',
    NLR: 'Isuzu',
};

const REGION_MAP = {
    A: 'Africa',
    B: 'Africa',
    C: 'Africa',
    D: 'Africa',
    E: 'Africa',
    F: 'Africa',
    G: 'Africa',
    H: 'Africa',
    J: 'Japan',
    K: 'Korea',
    L: 'China',
    M: 'India / Thailand',
    N: 'Turkey / Middle East',
    P: 'Philippines / Malaysia',
    R: 'Taiwan / Vietnam',
    S: 'United Kingdom',
    T: 'Czech Republic / Hungary',
    U: 'Europe',
    V: 'France / Spain / Austria',
    W: 'Germany',
    X: 'Russia / CIS',
    Y: 'Sweden / Belgium / Finland',
    Z: 'Italy',
    1: 'USA',
    4: 'USA',
    5: 'USA',
    2: 'Canada',
    3: 'Mexico',
    6: 'Australia',
    7: 'New Zealand',
    8: 'South America',
    9: 'Brazil / Argentina',
};

const YEAR_CODES = 'ABCDEFGHJKLMNPRSTVWXY123456789';

export const normalizeVin = (raw) =>
    typeof raw === 'string' ? raw.replace(/\s+/g, '').toUpperCase() : '';

export const isValidVin = (raw) => VIN_RE.test(normalizeVin(raw));

const findWmi = (vin) => {
    const three = vin.slice(0, 3);
    if (WMI_MAP[three]) return WMI_MAP[three];
    const two = vin.slice(0, 2);
    for (const key of Object.keys(WMI_MAP)) {
        if (key.length === 3 && key.startsWith(two)) {
            return WMI_MAP[key];
        }
    }
    return null;
};

export const decodeWmi = (raw) => {
    const vin = normalizeVin(raw);
    if (!isValidVin(vin)) return null;
    return findWmi(vin);
};

export const decodeRegion = (raw) => {
    const vin = normalizeVin(raw);
    if (!isValidVin(vin)) return null;
    return REGION_MAP[vin[0]] || null;
};

export const decodeYear = (raw) => {
    const vin = normalizeVin(raw);
    if (!isValidVin(vin)) return null;
    const code = vin[9];
    const idx = YEAR_CODES.indexOf(code);
    if (idx < 0) return null;
    const seventhIsLetter = /[A-Z]/.test(vin[6]);
    const base = seventhIsLetter ? 2010 : 1980;
    const year = base + idx;
    const now = new Date().getFullYear();
    if (year > now + 1) return year - 30;
    return year;
};

export const decodeVinLocal = (raw) => {
    const vin = normalizeVin(raw);
    if (!isValidVin(vin)) return null;
    return {
        vin,
        brand: findWmi(vin),
        region: REGION_MAP[vin[0]] || null,
        year: decodeYear(vin),
        source: 'local',
    };
};
